import { render, staticRenderFns } from "./SignContractAnnexDisputePopup.view.vue?vue&type=template&id=c28e77aa&"
import script from "./SignContractAnnexDisputePopup.view.vue?vue&type=script&lang=js&"
export * from "./SignContractAnnexDisputePopup.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c28e77aa')) {
      api.createRecord('c28e77aa', component.options)
    } else {
      api.reload('c28e77aa', component.options)
    }
    module.hot.accept("./SignContractAnnexDisputePopup.view.vue?vue&type=template&id=c28e77aa&", function () {
      api.rerender('c28e77aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/contract/annex/dispute/sign/SignContractAnnexDisputePopup.view.vue"
export default component.exports